import { render, staticRenderFns } from "./ParametrizacaoContratoList.vue?vue&type=template&id=0cfc2f2a&lang=html"
import script from "./ParametrizacaoContratoList.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoContratoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports